import { createSlice } from '@reduxjs/toolkit'

const initialState: any = {}

const feedbackQuestionsSlice = createSlice({
    name: `feedbackQuestions`,
    initialState: initialState,
    reducers: {
        getFeedbackQuestions: (state, action) => action.payload,
    },
})

export const feedbackQuestionsActions = feedbackQuestionsSlice.actions

export default feedbackQuestionsSlice.reducer
